import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import MailIcon from '@material-ui/icons/Mail'
import ContactPhone from '@material-ui/icons/ContactPhone'
import Person from '@material-ui/icons/Person'
import LocationOn from '@material-ui/icons/LocationOn'
import LocationCity from '@material-ui/icons/LocationCity'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import AccountCircle from '@material-ui/icons/AccountCircle'
import Timelapse from '@material-ui/icons/Timelapse'
import DirectionsCar from '@material-ui/icons/DirectionsCar'
import gql from 'graphql-tag'
// import BubbleChartIcon from '@material-ui/icons/BubbleChart'
// import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew'
import SettingsPowerIcon from '@material-ui/icons/SettingsPower'
import moment from 'moment'
import { Query } from 'react-apollo'
import Loader from '../../common/Loader'

const styles = theme => ({
  card: {
    wordBreak: 'break-all'
  },
  cardItemIcon: {
    paddingRight: '10px'
  }
})
const GET_ZM_KAM_DETAILS = gql`
  query GetAdminUserDetailsByRole($roleName: [String]) {
    getAdminUserDetailsByRole(roleName: $roleName) {
      id
      role
      username
    }
  }
`;
const roleNames = ["Zonal Manager(ZM)", "Key Account Manager(KAM)"];

class CustomerDetailsCard extends Component {
  render() {
    const { classes, clientDetail, actions } = this.props

    console.log('icons', clientDetail)
    return (
      <Query
        query={GET_ZM_KAM_DETAILS}
        variables={{
          roleName: roleNames,
        }}
        // fetchPolicy="network-only"
      >
        {({ loading: loadingZMKAM, error: errorZMKAM, data: { getAdminUserDetailsByRole } = {} }) => {
    if (loadingZMKAM) return <Loader />;
    if (errorZMKAM) return `Error with ZM/KAM details: ${errorZMKAM.message}`;

    // Process clients and ZM/KAM details
    const zonalManagers = getAdminUserDetailsByRole.filter((user) => user.role === "Zonal Manager(ZM)");
    const keyAccountManagers = getAdminUserDetailsByRole.filter((user) => user.role === "Key Account Manager(KAM)");
    const zonalManager = zonalManagers.find(zm => zm.id === clientDetail.zonalManager);
    const zonalManagerUsername = zonalManager ? zonalManager.username : 'N/A';

    const keyAccountManager = keyAccountManagers.find(zm => zm.id === clientDetail.keyAccountManager);
    const keyAccountManagerUsername = keyAccountManager ? keyAccountManager.username : 'N/A';
 
   return (
       <Card className={classes.card}>
        <CardHeader
          title={clientDetail.clientName}
          subheader="Customer Details"
        />
        <CardContent>
          {/* TODO: Needs more layout fixing */}
          <Grid container alignItems="baseline" spacing={16}>
            <Grid item xs={6} sm={4}>
              <Grid container alignItems="flex-start">
                <Grid item xs={12} md={'auto'} className={classes.cardItemIcon}>
                  <Person color="primary" />
                </Grid>
                <Grid item>
                  <Grid container>
                    <Grid item xs={12}>
                      <Typography variant="body2">Contact Person:</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="body1">
                        {clientDetail.contactPerson || 'N/A'}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={6} sm={4}>
              <Grid container alignItems="flex-start">
                <Grid item xs={12} md={'auto'} className={classes.cardItemIcon}>
                  <AccountCircle color="primary" />
                </Grid>
                <Grid item>
                  <Grid container>
                    <Grid item xs={12}>
                      <Typography variant="body2">Account Type:</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="body1">
                        {clientDetail.type || 'N/A'}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={6} sm={4}>
              <Grid container alignItems="flex-start">
                <Grid item xs={12} md={'auto'} className={classes.cardItemIcon}>
                  <LocationOn color="primary" />
                </Grid>
                <Grid item>
                  <Grid container>
                    <Grid item xs={12}>
                      <Typography variant="body2">Address:</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="body1">
                        {clientDetail.address || 'N/A'}
                      </Typography>
                      <Typography variant="body1">
                        {(clientDetail.city || 'N/A') +
                          ' ' +
                          (clientDetail.state.name || '') +
                          ' ' +
                          (clientDetail.country.name || '')}
                      </Typography>
                      <Typography variant="body1">
                        {clientDetail.pincode || ''}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            {/* <Grid item xs={6} sm={4}>
              <Grid container alignItems="flex-start">
                <Grid item xs={12} md={'auto'} className={classes.cardItemIcon}>
                  <LocationCity color="primary" />
                </Grid>
                <Grid item>
                  <Grid container>
                    <Grid item xs={12}>
                      <Typography variant="body2">Location:</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="body1">
                        {(clientDetail.city || 'N/A') +
                          ' ' +
                          (clientDetail.state.name || '') +
                          ' ' +
                          (clientDetail.country.name || '')}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid> */}

            <Grid item xs={6} sm={4}>
              <Grid container alignItems="flex-start">
                <Grid item xs={12} md={'auto'} className={classes.cardItemIcon}>
                  <MailIcon color="primary" />
                </Grid>
                <Grid item>
                  <Grid container>
                    <Grid item xs={12}>
                      <Typography variant="body2">E-Mail:</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="body1">
                        {clientDetail.email || 'N/A'}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={6} sm={4}>
              <Grid container alignItems="flex-start">
                <Grid item xs={12} md={'auto'} className={classes.cardItemIcon}>
                  <ContactPhone color="primary" />
                </Grid>
                <Grid item>
                  <Grid container>
                    <Grid item xs={12}>
                      <Typography variant="body2">Contact Number:</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="body1">
                        {clientDetail.contactNumber || 'N/A'}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {/* eslint-disable */}
            <Grid item xs={6} sm={4}>
              <Grid container alignItems="flex-start">
                <Grid item xs={12} md={'auto'} className={classes.cardItemIcon}>
                  <Timelapse color="primary" />
                </Grid>
                <Grid item>
                  <Grid container>
                    <Grid item xs={12}>
                      <Typography variant="body2">Deactivates On:</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="body1">
                        {clientDetail.expiryDate
                          ? moment
                              .unix(clientDetail.expiryDate)
                              .format('MMM Do YYYY, hh:mm A')
                          : 'N/A'}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {/* eslint-enable */}

            {clientDetail.channelPartnerName ? (
    <Grid item xs={6} sm={4}>
      <Grid container alignItems="flex-start">
        <Grid item xs={12} md={'auto'} className={classes.cardItemIcon}>
        <Person color="primary" />
        </Grid>
        <Grid item>
          <Grid container>
            <Grid item xs={12}>
              <Typography variant="body2">CHANNEL PARTNER:</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1">
                {clientDetail.channelPartnerName}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  ) : null}
  
  {clientDetail.zonalManager?( <Grid item xs={6} sm={4}>
        <Grid container alignItems="flex-start">
          <Grid item xs={12} md={'auto'} className={classes.cardItemIcon}>
          <Person color="primary" />
          </Grid>
          <Grid item>
            <Grid container>
              <Grid item xs={12}>
                <Typography variant="body2">ZONAL MANAGER:</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1">
                  {/* {zonalManagerUsername !== 'N/A' ? zonalManagerUsername : clientDetail.zonalManager}
                  {zonalManagers.find(zm => zm.id === clientDetail.zonalManager)} */}
                  {zonalManagerUsername}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>):null}

      {clientDetail.keyAccountManager?(<Grid item xs={6} sm={4}>
        <Grid container alignItems="flex-start">
          <Grid item xs={12} md={'auto'} className={classes.cardItemIcon}>
          <Person color="primary" />
          </Grid>
          <Grid item>
            <Grid container>
              <Grid item xs={12}>
                <Typography variant="body2">KEY ACCOUNT MANAGER:</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1">
                  {/* {keyAccountManagerUsername !== 'N/A' ? keyAccountManagerUsername : clientDetail.keyAccountManager} */}
                  {keyAccountManagerUsername}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>):null}

            <Grid item xs={6} sm={4}>
              <Grid container alignItems="flex-start">
                <Grid item xs={12} md={'auto'} className={classes.cardItemIcon}>
                  <SettingsPowerIcon color="primary" />
                </Grid>
                <Grid item>
                  <Grid container>
                    <Grid item xs={12}>
                      <Typography variant="body2">Client Status:</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="body1">
                        {clientDetail.status ? 'Active' : 'Inactive' || 'N/A'}
                        {console.log('clientDetail.status', clientDetail)}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6} sm={4}>
              <Grid container alignItems="flex-start">
                <Grid item xs={12} md={'auto'} className={classes.cardItemIcon}>
                  <DirectionsCar color="primary" />
                </Grid>
                <Grid item>
                  <Grid container>
                    <Grid item xs={12}>
                      <Typography variant="body2">Total Potential Vehicles:</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="body1">
                        {clientDetail.totalPotentialVehicles || 'N/A'}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
        {actions && <CardActions>{actions()}</CardActions>}
        </Card>
      );
    }}
  </Query>
    )
  }}
CustomerDetailsCard.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(CustomerDetailsCard)


// WEBPACK FOOTER //
// ./src/components/Modules/CustomerDetailsCard/index.jsx